// extracted by mini-css-extract-plugin
export default {"mainContainer":"exotelResearch_mainContainer__Txlji","leftSubContainer":"exotelResearch_leftSubContainer__bzdE6","rightSubContainer":"exotelResearch_rightSubContainer__XwIDq"};